
export const pageBannerShippingInfo: string[] = [
    'Free shipping on U.S. orders $99+',
    'Free shipping on Canada & Mexico orders $199+',
    'Free shipping on International orders $299+',
    'Learn more about our <a class="v-custom-link" href="/company/shipping">shipping policies</a>'
];

export const pageBannerCreditHoldAlert: string[] = [
    'Your account is on credit hold. Please pay <strong>past due <a class="v-custom-link" href="/account/invoices">invoices</a></strong> to place new orders.'
];
